<template>
        <span style="float: right;" >
                <svg  @mouseover="mouseOver" @mouseout="mouseOut" id="info-icon" height="20px" viewBox="0 0 512 512" width="20px" xmlns="http://www.w3.org/2000/svg" fill="lightgrey"><path
                        d="m277.332031 384c0 11.78125-9.550781 21.332031-21.332031 21.332031s-21.332031-9.550781-21.332031-21.332031 9.550781-21.332031 21.332031-21.332031 21.332031 9.550781 21.332031 21.332031zm0 0"/><path
                        d="m256 512c-141.164062 0-256-114.835938-256-256s114.835938-256 256-256 256 114.835938 256 256-114.835938 256-256 256zm0-480c-123.519531 0-224 100.480469-224 224s100.480469 224 224 224 224-100.480469 224-224-100.480469-224-224-224zm0 0"/><path
                        d="m256 314.667969c-8.832031 0-16-7.167969-16-16v-21.546875c0-20.308594 12.886719-38.507813 32.042969-45.269532 25.492187-8.980468 42.625-36.140624 42.625-55.851562 0-32.363281-26.304688-58.667969-58.667969-58.667969s-58.667969 26.304688-58.667969 58.667969c0 8.832031-7.167969 16-16 16s-16-7.167969-16-16c0-49.984375 40.664063-90.667969 90.667969-90.667969s90.667969 40.683594 90.667969 90.667969c0 35.585938-28.097657 73.367188-63.980469 86.039062-6.398438 2.238282-10.6875 8.316407-10.6875 15.101563v21.527344c0 8.832031-7.167969 16-16 16zm0 0"/>
                </svg>
                <span class="info-text" :class="active ? '' : 'd-none'" v-text="information"></span>
        </span>
</template>

<script>
  export default {
    name: 'InformationIcon',
    props: {
      information: {
        default: 'Placeholder informatie'
      },
    },
    data(){
      return {
        active: false,
      }
    },
    components: {},

    methods: {
      mouseOver(){
        this.active = true;

      },
      mouseOut(){
        this.active = false;
      }
    }
  }
</script>

<style scoped lang="scss">
        #info-icon:hover {
                fill: #3DB0C7;
                transition: all ease 0.3s;
        }

        .info-text {
                position: absolute;
                padding: 15px;
                margin: -50px -5px;
                border-radius: 25px 10px 25px 0;
                background-color: white;
                border: 1px solid #3DB0C7;
                animation: fade-in 0.5s;
                box-shadow: inset 0 0 15px lighten(#3DB0C7, 35%);
        }
        @keyframes fade-in {
                0%   { opacity: 0; }
                100% { opacity: 1; }
        }
</style>